export default __webpack_public_path__ + "static/media/logout.80763ba7.svg";